import React, { useState, useEffect, useRef } from 'react';

const SFDotsProgress = ({ dotProgressMap, randomCategory, categoryMasteryCount, masteredCategories, defaultMasteryCount }) => {

    const [dots, setDots] = useState([]);
    const [showDots, setShowDots] = useState(false);
    const containerRef = useRef(null);

    function distributeDots(dataArr, masteryCount) {
        let dots = [];
        let row = [];

        for (let value of dataArr) {
            if (row.length === masteryCount) {
                dots.push(row);
                row = [];
            }

            row.push(value ? 1 : 0);

            if (value === false) {
                while (row.length < masteryCount) {
                    row.push(-1);
                }
                dots.push(row);
                row = [];
            }
        }

        while (row.length > 0 && row.length < masteryCount) {
            row.push(-1);
        }

        if (row.length > 0) {
            dots.push(row);
        }

        return dots;
    }

    useEffect(() => {
        if (randomCategory && dotProgressMap && categoryMasteryCount) {
            let dataArr = dotProgressMap[randomCategory];
            let masteryCount = categoryMasteryCount[randomCategory];
            if (masteryCount === 0) masteryCount = defaultMasteryCount;
            if (masteryCount <= 10) {
                setShowDots(true)
            }
            if (dataArr && masteryCount) {
                let updatedDots = distributeDots(dataArr, masteryCount);
                let l = dataArr.length;
                if (dataArr[l - 1] === false) {
                    let lastArr = Array.from({ length: masteryCount }).map((i) => -1)
                    updatedDots.push(lastArr)
                }
                setDots(updatedDots);
            } else {
                let updatedDots = [];

                let lastArr = Array.from({ length: masteryCount }).map((i) => -1)
                updatedDots.push(lastArr);
                setDots(updatedDots);
            }
        }
    }, [randomCategory, dotProgressMap])

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [dots]);

    return (
        <div ref={containerRef} className='justify-content-start flex-column mt-2 mb-2' style={{
            maxHeight: '160px',
            overflowY: 'auto',
            display: showDots ? 'flex' : 'none',
        }}>
            {dots?.map((dotArr, dotArrInd) => {
                let dotSize = Math.max(6, 16 - dotArr.length);
                return (
                    <div key={dotArrInd} className='d-flex justify-content-start w-100 mb-1'
                        style={{
                            gap: '3px',
                            // border: dotArrInd === dots.length - 1 ? '1px solid #333' : '',
                            // background: dotArrInd === dots.length - 1 ? '#fff' : '',
                            padding: '2px 4px',
                            borderRadius: '10px'
                        }}
                    >
                        {dotArr ? dotArr.map((val, index) => {
                            let className = "sf-circle ";
                            switch (val) {
                                case -1:
                                    className += " grey-dot"
                                    break;
                                case 0:
                                    className += " red-dot"
                                    break;
                                case 1:
                                    className += " green-dot"
                                    break;
                                default:
                                    break;
                            }

                            return (
                                <div
                                    key={index}
                                    className={className}
                                    style={{ width: `${dotSize}px`, height: `${dotSize}px`, borderRadius: '50%' }}
                                ></div>
                            )
                        }) : null}
                    </div>
                );
            })}
        </div>
    );
}

export default SFDotsProgress;
